<template>
<!-- / -->
</template>


<script>

    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props: {
          propsIsMemberLogin: {
            type: Boolean,
            default: false
          }
        },
        mounted() {
            console.log('HeaderToastComponent mounted.')

            //if login
            if(this.query_params && this.query_params['action']=='login' && this.propsIsMemberLogin) {
              this.showLoginToast();
            }
            //if logout
            else if(this.query_params && this.query_params['action']=='logout' && !this.propsIsMemberLogin) {
              this.showLogoutToast();
            }

        },
        methods: {
          showLoginToast: function() {
            this.$bvToast.toast('ログインしました。', {
              title: '中谷財団アーカイブ',
              variant: 'primary',
              solid: true
            })
          },
          showLogoutToast: function() {
            this.$bvToast.toast('ログアウトしました。', {
              title: '中谷財団アーカイブ',
              variant: 'danger',
              solid: true
            })
          }
        }
    }
</script>
